<template>
  <div class="appBody">
    <div class="appBody-B">
      <div class="appBody-A">
        <!-- 左侧盒子 -->
        <div class="leftBody">
          <div class="bodyTitle">
            <p class="title-txt">项目概括</p>
          </div>
          <!-- 项目信息 -->
          <div class="projectData">
            <p>建设单位：{{ participatingUnits.buildingName[0] || '' }}</p>
            <p>EPC总承包单位：中国建筑第八工程局有限公司</p>
            <p>设计单位：机械工业勘察设计研究院有限公司</p>
            <p>监理单位：上海同济工程项目管理咨询有限公司</p>
          </div>
          <div class="personnel">
            <div class="personnel-title"><p class="title-txt">人员管理</p></div>
            <div class="personnel-body"></div>
          </div>
        </div>
        <!-- 右侧盒子 -->
        <div class="rightBody">
          <div class="bodyTitle">
            <p class="title-txt">环境监测</p>

          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'

export default {
  data() {
    return {
      projectId: util.session.get('groupId'),
      participatingUnits: [],    // 参建单位
    }
  },
  created() {
    this.getUnits()
  },

  methods: {
    // 获取参建单位
    getUnits() {
      myHttp.getProjectMessByProjectId({
        projectId: this.projectId
      }).then(resp => {
        console.log(resp);
        if (resp.data.code === 200) {
          this.participatingUnits = resp.data.data
        }
      })
    },
    ehcartsWeek(date, listData, name) {

      this.$echarts.init(document.querySelector('.ec')).dispose();
      let myChart1 = this.$echarts.init(document.querySelector('.ec'));
      option = {
        backgroundColor: '#071C32',
        tooltip: {
          show: true,
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, .16)', // 设置背景颜色
          textStyle: {
            color: '#fff',
            fontSize: 14
          },
          borderColor: 'rgba(255, 255, 255, .16)',
          axisPointer: {
            lineStyle: {
              color: 'rgba(28, 124, 196, .6)'
            },
          },
          // formatter: "{b}人员类别统计<br>{c}人"
          formatter: function (params, ticket, callback) {
            var htmlStr = '';
            for (var i = 0; i < params.length; i++) {
              var param = params[i];
              var xName = param.name + '风险地区返秦情况';//x轴的名称
              var seriesName = param.seriesName;//图例名称
              var value = param.value;//y轴值
              var color = param.color;//图例颜色
              if (i === 0) {
                htmlStr += xName + '<br/>';//x轴的名称
              }
              htmlStr += '<div>';
              htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>';//一个点
              htmlStr += seriesName + '：' + value + '人';//圆点后面显示的文本
              htmlStr += '</div>';
            }
            return htmlStr;
          }
        },
        color: ['#FF0000', '#F39800', '#16D6FF', '#25D677'],
        legend: {
          // icon: 'circle',
          // itemWidth: 10,
          itemGap: 4,
          x: 'left',
          top: '1%',
          textStyle: {
            color: '#fff',
            fontSize: 13,
            // padding:[0, 6, 0, 6],
          }
        },
        grid: {
          top: '18%',
          left: '12%',
          right: '2%',
          bottom: '18%',
        },
        xAxis: [
          {
            type: 'category',
            axisLine: {
              lineStyle: {
                color: '#2D4377'
              }
            },
            axisLabel: {
              interval: 0,
              align: 'center',
              rotate: '26',
              margin: '20',
              textStyle: {
                fontSize: 14,
                color: '#A9C3F0'
              }
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false
            },
            boundaryGap: true,
            data: ['08-30', '08-31', '09-01', '09-02', '09-03', '09-04', '09-05'], //this.$moment(data.times).format("HH-mm") ,
          },
        ],

        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 500,
            splitNumber: 6,
            axisLine: {
              lineStyle: {
                color: '#2D4377'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#2D4377',
                type: 'dashed'
              },
            },
            axisLabel: {
              color: '#A9C3F0',
              textStyle: {
                fontSize: 14
              }
            },
            axisTick: {
              show: false
            }
          },
        ],
        series: [
          {
            name: '高风险地区',
            type: 'line',
            showSymbol: true,
            symbolSize: 8,
            lineStyle: {
              normal: {
                color: '#FF2E2E',
              },
            },
            itemStyle: {
              color: '#FF2E2E',
              borderColor: '#FF2E2E',
              borderWidth: 2,
            },
            // emphasis: {
            //     itemStyle: {
            //         color: "#fff",
            //         borderColor: "#FF2E2E",
            //         borderWidth: 2,
            //     },
            // },
            data: [60, 100, 90, 95, 65, 42, 50], //data.values
          },
          {
            name: '中风险地区',
            type: 'line',
            showSymbol: true,
            symbolSize: 8,
            lineStyle: {
              normal: {
                color: '#F39800',
              },
            },
            itemStyle: {
              color: '#F39800',
              borderColor: '#F39800',
              borderWidth: 2,
            },
            // emphasis: {
            //     itemStyle: {
            //         color: "#fff",
            //         borderColor: "#F39800",
            //         borderWidth: 2,
            //     },
            // },
            data: [90, 200, 300, 130, 100, 120, 180], //data.values
          },
          {
            name: '低风险地区',
            type: 'line',
            showSymbol: true,
            symbolSize: 8,
            lineStyle: {
              normal: {
                color: '#16D6FF',
              },
            },
            itemStyle: {
              color: '#16D6FF',
              borderColor: '#16D6FF',
              borderWidth: 2,
            },
            // emphasis: {
            //     itemStyle: {
            //         color: "#fff",
            //         borderColor: "#16D6FF",
            //         borderWidth: 2,
            //     },
            // },
            data: [220, 220, 400, 380, 310, 410, 450], //data.values
          },
          {
            name: '常态化地区',
            type: 'line',
            showSymbol: true,
            symbolSize: 8,
            lineStyle: {
              normal: {
                color: '#25D677',
              },
            },
            itemStyle: {
              color: '#25D677',
              borderColor: '#25D677',
              borderWidth: 2,
            },
            // emphasis: {
            //     itemStyle: {
            //         color: "#fff",
            //         borderColor: "#25D677",
            //         borderWidth: 2,
            //     },
            // },
            data: [300, 300, 190, 320, 280, 220, 310], //data.values
          },
        ],
      };


      window.addEventListener('resize', function () {
        myChart1.resize()
      });
    },

  },
}
</script>

<style>
.appBody {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: url('../../assets/image/screenImg/hom.png');
}

.appBody-A {
  padding-left: 16px;
  padding-right: 16px;
  width: 100%;
  height: 100%;
  background: url('../../assets/image/screenImg/hom.png') ;
  background-size: 100%;
  padding-top: 5.4167vw;
}

.appBody-B {
  z-index: -1;
  width: 100%;
  height: 100%;
  /* background: url('../../../../02.jpg'); */
  background-size: 100%;
}

.rightBody {
  float: right;
  width: 31.0417vw;
  /* background: pink; */
  height: 10.4167vw;
}

.leftBody {

  float: left;
  width: 31.0417vw;
  /* background: pink; */
  height: 10.4167vw;
}

.bodyTitle {
  padding-left: .5208vw;
  width: 31.0417vw;
  height: 2.0833vw;
  background: #002367;
  opacity: 0.44;

}

.title-txt {
  text-align: left;
  line-height: 2.0833vw;
  font-family: PingFangSC-Regular;
  font-size: .8333vw;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #01ffff;
}

.projectData {
  text-align: left;
  height: 15.3646vw;
  width: 100%;
  background: pink;

}

.projectData p {
  font-family: PingFangSC-Regular;
  font-size: .7292vw;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
  line-height: 1.5vw;
}

.personnel {
  width: 22.1875vw;
}

.personnel-title {
  padding-left: .5208vw;
  width: 100%;
  height: 2.0833vw;
  background: #002367;
  opacity: 0.44;
}

.personnel-body {
  height: 13.9063vw;
  width: 100%;
  background: #ffffff;
}
</style>